import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const Input = styled.input`
  display: none;
`;

export interface IUploadButtonProps {
  isUploading: boolean;
  uploadFile: () => void;
  uploadPercentage?: number;
}

const UploadButton = ({
  isUploading,
  uploadFile,
  uploadPercentage
}: IUploadButtonProps) => {
  const startUpload = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.getElementById('upload-input').click();
  };

  return (
    <>
      <Button
        loading={isUploading}
        icon={<UploadOutlined />}
        onClick={() => {
          startUpload();
        }}
      >
        Upload Pcode CSV
        {uploadPercentage !== 0 &&
          uploadPercentage !== 100 &&
          ` ${uploadPercentage}%`}
      </Button>
      <Input
        id="upload-input"
        onClick={(e: SyntheticEvent) => {
          (e.target as HTMLInputElement).value = '';
        }}
        type="file"
        onChange={uploadFile}
      />
    </>
  );
};

UploadButton.propTypes = {
  uploadFile: PropTypes.func.isRequired,
  isUploading: PropTypes.bool.isRequired
};

export default UploadButton;
